<!--
  -panel.component.html -->
<div class="edit-panel">
  <div *ngIf="displayBanner && !stage?.stage_name" style="padding:0;">
    <img src="../../../assets/images/campaign-stage-banner.png" alt=""
      style="width: 100%; height:91vh; object-fit: contain;">
  </div>
  <div *ngIf="!displayBanner">

    <form [formGroup]="stageFormGroup" *ngIf="isInEditMode.editMode && stage" (ngSubmit)="onSaveForm1()">
      <div class="panel-heading">
        <span class="Heading-text"
          style="max-width: 20vw;white-space: nowrap;overflow: hidden;display: block;text-overflow: ellipsis;width: 19vw; cursor:default;"
          matTooltip="{{ stageFormGroup.get('stepName').value || 'First email' }}"
          [matTooltipClass]="{ 'red-tooltip text-black': true }">
          {{ stageFormGroup.get("stepName").value || "First email" }}
        </span>
      </div>
      <div class="row mx-0 py-2">
        <div class="col-4">
          <label class="field-label">Email Step Name <span class="text-danger">*</span>: </label>
          <!-- <br /> -->
          <app-custom-input
            formControlName="stepName"
            class="mt-1"
            placeholder="Enter email step name">
          </app-custom-input>
           <p *ngIf="stageFormGroup.get('stepName').errors?.required && (stageFormGroup['controls'].stepName.dirty || stageFormGroup['controls'].stepName.touched)"
            class="f-12 text-danger m-0"> Email Step Name is required</p>
          <p class="f-12 text-danger m-0" *ngIf="stageFormGroup.get('stepName').hasError('notOnlyWhitespace')">
            Email Step Name cannot be only whitespace.
          </p>
          <!-- <input data-testid="auto-edit-panel-input-1" type="text" formControlName="stepName" class="camp-name"
            [ngClass]="{'disabled-option': (campaign_details.status!=3), 'ml-1': (campaign_details.status!=3)}" />
          <p *ngIf="stageFormGroup.get('stepName').errors?.required && (stageFormGroup['controls'].stepName.dirty || stageFormGroup['controls'].stepName.touched)"
            class="f-12 text-danger m-0"> Email Step Name is required</p>
          <p class="f-12 text-danger m-0" *ngIf="stageFormGroup.get('stepName').hasError('notOnlyWhitespace')">
            Email Step Name cannot be only whitespace.
          </p> -->
        </div>
        <div class=" col-8">
          <label class="field-label">Email Template: </label>
          <!-- <br /> -->
          <app-custom-dropdown
            class="w-100 mt-1"
            formControlName="emailTemplate"
            placeholder="Select email template"
            (selectionChange)="selectedTemplateOption($event)">
            <app-dropdown-option *ngFor="let template of customtempList" [value]="template.templateid" [label]="template.actionname">
            </app-dropdown-option>
          </app-custom-dropdown>
          <!-- <select data-testid="auto-edit-panel-select-1" formControlName="emailTemplate" class="templ-name w-100" style="padding-top:3px;"
            (change)="selectedTemplateOption($event)">
            <option [value]="null" disabled [selected]="true">{{ stage?.subject || "Select email template" }}</option>
            <option *ngFor="let template of customtempList" [value]="template.templateid">
              {{ template.actionname }}
            </option>
          </select> -->
        </div>
      </div>
      <hr>
      <div class="" *ngIf="!stage.after_id && !prevStageId">
        <div class="row mx-0 py-2">

          <div class=" col d-flex align-items-center" style="border-right: 1px solid #d9d9d9;">
            <label class="field-label mr-5 ">When: </label>
            <!-- <span class="mx-3" style="color:#d9d9d9;" >|</span>  -->
            <div class="d-flex align-items-center" formGroupName="schedule">
              <label class="f-14 mb-0"> Time</label>
              <app-custom-input
                style="width: fit-content;"
                placeholder="From"
                id="startTime"
                type='time'
                formControlName="startTime"
                name="startTime"
                class="mx-2"
              ></app-custom-input>
              <!-- <input data-testid="auto-edit-panel-input-2" placeholder="From" id="startTime" style="width: fit-content; border: 1px solid #ced4da; border-radius: 0.25rem;"
                type='time' formControlName="startTime" name="startTime" class="form-control form-control-sm mx-2"
                [ngClass]="{'disabled-option':  (campaign_details.status!=3), 'ml-1': (campaign_details.status!=3)}" /> -->

              <app-custom-input
                style="width: fit-content;"
                placeholder="To"
                id="endTime"
                type='time'
                formControlName="endTime"
                name="endTime"
                class="mx-2"
              ></app-custom-input>
              <!-- <div> -->

              <!-- <select data-testid="auto-edit-panel-select-2" formControlName="timezone" class="form-control form-control-sm" style=" border: 1px solid #ced4da; border-radius: 0.25rem;" [ngClass]="{'disabled-option': (campaign_details.status!=3), 'ml-1': (campaign_details.status!=3)}">
                <option [value]="null" selected><i class="fa fa-email"></i> Timezone</option>
                <option *ngFor="let tz of timezones" [value]="tz">
                  <i class="fa-regular fa-globe" style="color: #484b59;"></i> {{ tz }}
                </option>
              </select> -->
              <!-- </div> -->
              <!-- <div *ngIf="stageFormGroup.get('endTime').invalid"> -->
                <!-- </div> -->
                 <!-- <div class="position-relative gray-text mt-3px d-flex" style="width: 330px;">
                    <input data-testid="auto-edit-panel-input-3"  type="text" placeholder="Time Zones(Enter City)"
                      matInput
                      (input)="searchTimezone($event)"
                      class="wc-form-control nobg"
                      formControlName="timezone"
                      [matAutocomplete]="country_name"
                      (click)="showdefaultTimezone()">
                      <i class="fa-solid fa-angle-down timezon-drop"></i>


                 <mat-autocomplete #country_name="matAutocomplete"
  (optionSelected)="selectOption($event)"   [displayWith]="displayTimezone"

  >

  <mat-option *ngFor="let tz of filteredOptions"
              [value]="tz.timeZone"
              class="timezone-option">

    <span class="tz-name">{{ tz.timeZone }}</span>
    <span class="tz-offset">({{ tz.offsetLabel }})</span>

  </mat-option>
  </mat-autocomplete>

                  </div> -->
              <app-custom-dropdown
                class="ml-2"
                [filterable]="true"
                formControlName="timezone"
                placeholderIcon="fa-solid fa-globe"
                placeholder="Select Timezone"
                >
                <app-dropdown-option *ngFor="let tz of timeZonesList" [value]="tz.timeZone" [label]="tz.timeZone + ' (' + tz.offsetLabel + ')'"></app-dropdown-option>
              </app-custom-dropdown>
            </div>
            <span *ngIf="stageFormGroup.get('schedule').get('endTime').invalid" class="f-12 text-danger m-0">To time
              should be higher than From time.</span>
            <span *ngIf="stageFormGroup.get('schedule').get('startTime').invalid" class="f-12 text-danger m-0">From time
              should be smaller than To time.</span>
            <span *ngIf="stageFormGroup.get('schedule').get('timezone').errors?.required && (stageFormGroup.get('schedule').get('timezone').touched || stageFormGroup.get('schedule').get('timezone').dirty)" class="f-12 text-danger m-0">Timezone is required.</span>
            <span *ngIf="stageFormGroup.get('schedule').get('timezone').errors?.invalidTimezone && (stageFormGroup.get('schedule').get('timezone').touched || stageFormGroup.get('schedule').get('timezone').dirty)" class="f-12 text-danger m-0">Please select a timezone from the dropdown.</span>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="field-label">Follow-up on: </label>
            <!-- <select data-testid="auto-edit-panel-select-3" formControlName="regularDays" class="form-control form-control-sm ml-1"
              style="width: auto; border: 1px solid #ced4da; border-radius: 0.25rem;"
              [ngClass]="{'disabled-option': (campaign_details.status!=3) }">
              <option [value]="0">Business days</option>
              <option [value]="1">Regular days</option>
            </select> -->
            <app-custom-dropdown
              class="ml-2"
              formControlName="regularDays"
              [options]="[
                { label: 'Business days', value: 0 },
                { label: 'Regular days', value: 1 }
              ]"
              placeholder="Select Follow-up type"
              >
            </app-custom-dropdown>
          </div>
        </div>

        <!-- <select data-testid="auto-edit-panel-select-4" formControlName="hours" class="hrs">
          <option *ngFor="let hour of timeOptions" [value]="hour">
            {{ hour }} hours
          </option>
        </select>
        <select data-testid="auto-edit-panel-select-5" formControlName="minutes" class="min">
          <option *ngFor="let minute of timeOptions" [value]="minute">
            {{ minute }} minutes
          </option>
        </select> -->
      </div>
      <div class="sec d-flex align-items-center py-1" *ngIf="stage?.after_id && prevStageId">
        <label class="field-label mr-3">When<span class="text-danger">*</span>: </label>
        <span class="snd-aftr ml-1"> Send email after</span>
        <app-custom-input
          type="number"
          style="width: 5%;"
          formControlName="after_minutes"
          class="mx-1 ml-2"
          placeholder="1"
        ></app-custom-input>
        <!-- <input data-testid="auto-edit-panel-input-4" type="number" formControlName="after_minutes" class=" form-control form-control-sm mx-1 ml-2"
          style="width: 58px; height: 30px; border: 1px solid #ced4da; border-radius: 0.25rem; " placeholder="0"
          [ngClass]="{'disabled-option':  (campaign_details.status!=3), 'ml-1': (campaign_details.status!=3)}"> -->
        <span class="form-control form-control-sm mx-1 p-1 mr-2 f-12 gray-text"
          style="width: auto; height: 30px; display:inline-flex; align-items:center; border: none; background: transparent;">
          {{ stageFormGroup.get('regularDays').value == 1 ? 'Regular days' : 'Business days' }}
        </span>
        on no reply
      </div>
      <div style="margin-left: 14rem;" *ngIf="stage?.after_id && prevStageId">
        <p *ngIf="stageFormGroup.get('after_minutes').errors?.required && (stageFormGroup['controls'].after_minutes.dirty || stageFormGroup['controls'].after_minutes.touched)"
          class="f-12 text-danger m-0"> This field is required</p>
        <p *ngIf="stageFormGroup.get('after_minutes').errors?.min && (stageFormGroup['controls'].after_minutes.dirty || stageFormGroup['controls'].after_minutes.touched)"
          class="f-12 text-danger m-0"> Value should be greater than 0</p>
        <p *ngIf="stageFormGroup.get('after_minutes').errors?.max && (stageFormGroup['controls'].after_minutes.dirty || stageFormGroup['controls'].after_minutes.touched)"
          class="f-12 text-danger m-0"> Maximum delay is 30 days</p>
      </div>

      <hr />
      <div class="sec d-flex py-1">
        <label class="field-label mr-5">To<span class="text-danger">*</span>: </label>
        <app-custom-dropdown
          class="ml-2"
          [naked]="true"
          formControlName="to"
          placeholder="Select candidate email type">
          <app-dropdown-option *ngFor="let option of toOptions" [value]="getEmailPreferenceValue(option)" [label]="option">
          </app-dropdown-option>
        </app-custom-dropdown>
        <!-- <select data-testid="auto-edit-panel-select-6" formControlName="to" class="form-control form-control-sm ml-2" style="width: fit-content;"
          placeholder="Select candidate email type"
          [ngClass]="{'disabled-option': (stage?.after_id && prevStageId) || (campaign_details.status!=3), 'ml-3': (stage?.after_id && prevStageId) || (campaign_details.status!=3) }">
          <option [value]="null" disabled>Select candidate email type</option>
          <option *ngFor="let option of toOptions" [value]="getEmailPreferenceValue(option)">
            {{ option }}
          </option>
        </select> -->
        <p *ngIf="stageFormGroup.get('to').errors?.required && (stageFormGroup['controls'].to.dirty || stageFormGroup['controls'].to.touched)"
          class="f-12 text-danger m-0"> This field is required</p>
        <!-- <br /> -->
      </div>
      <hr />
      <div class="sec d-flex py-1">
        <label class="field-label mr-3">From<span class="text-danger">*</span>:</label>
        <app-custom-dropdown
          [naked]="true"
          formControlName="from"
          placeholder="Select email id">
          <app-dropdown-option *ngFor="let option of integratedemailsarray" [value]="option.useremailintegrationid" [label]="option.emailid"></app-dropdown-option>
        </app-custom-dropdown>
        <!-- <select data-testid="auto-edit-panel-select-7" formControlName="from" class="form-control form-control-sm" style="width: fit-content;"
          [ngClass]="{'disabled-option': stage?.after_id && prevStageId || (campaign_details.status!=3), 'ml-1': stage?.after_id && prevStageId   || (campaign_details.status!=3)}">
          <option [value]="null" disabled>Select email id</option>
          <option *ngFor="let option of integratedemailsarray" [value]="option.useremailintegrationid">
            {{ option.emailid }}
          </option>
        </select> -->
        <p *ngIf="stageFormGroup.get('from').errors?.required && (stageFormGroup['controls'].from.dirty || stageFormGroup['controls'].from.touched)"
          class="f-12 text-danger m-0"> This field is required</p>
      </div>
      <hr />
      <div class="">
        <div class="sec align-items-start ">
          <div class="d-flex subject-input align-items-center py-1">
            <label class="field-label mr-1">Subject<span class="text-danger">*</span>: </label>
            <div style="width: 80%;">
              <app-custom-input
                type="text"
                [naked]="true"
                #subject="appCustomInput"
                formControlName="subject"
                placeholder="Write subject here"
                (click)="getCursorPosition('subject')"
              ></app-custom-input>
              <!-- <input data-testid="auto-edit-panel-input-5" type="text" formControlName="subject" #subject (click)="getCursorPosition('subject')"
                [ngClass]="{'disabled-option': keepThreading }"
                class="form-control form-control-sm subject-input" placeholder="Write subject here" /> -->
            </div>
            <div class="position-relative w-20 mx-2">
              <!-- <span class="selectdrop-down position-absolute tr0 f-12 mt-6"><i class="fas fa-chevron-down"></i></span> -->
              <app-custom-dropdown
                class="ml-2"
                formControlName="placeholder"
                (selectionChange)="selectplaceholder($event, 'subject')"
                placeholder="Select variable">
                <app-dropdown-option *ngFor="let x of placeholderlist" [value]="x.value" [label]="x.value"></app-dropdown-option>
              </app-custom-dropdown>
              <!-- <select data-testid="auto-edit-panel-select-8" class="wc-form-control placeholder nobg position-relative" [disabled]="!placeid"
                (change)="selectplaceholder($event, 'placeholder')">
                <option value=null [selected]='!placeid'>Select variable</option>
                <option *ngFor="let x of placeholderlist" [value]="x.value">{{x.value}}</option>
              </select> -->
            </div>
          </div>
          <div class="m-0" *ngIf="stageFormGroup .get('subject').errors">
            <p *ngIf="stageFormGroup.get('subject').errors?.required && (stageFormGroup['controls'].subject.touched)"
              class="f-12 text-danger m-0 mb-2"> Subject is required</p>
            <p class="f-12 text-danger m-0 mb-2" *ngIf="stageFormGroup.get('subject').hasError('notOnlyWhitespace')">
              Subject cannot be only whitespace.
            </p>
          </div>
          <div *ngIf="keepThreading" class="mb-2 f-12 d-flex align-items-center">
            <i class="fa fa-info-circle mr-1"></i> Using the First Email subject to keep emails in the same thread
          </div>
          <!-- <br /> -->
        </div>
        <!-- <hr /> -->
        <div class="text-editor-in-edit-mode mr-2 position-relative">

            <p-editor #Editor (onInit)="setInstance($event)" formControlName="body" (onTextChange)="getCursorPosition('body');" (click)="getCursorPosition('body');" (change)="selectplaceholder($event, 'editor')"
             [modules]="modules"
>
              <p-header class="d-flex justify-content-start" id="editor-toolbar">
                 <span class="ql-formats">
      <button data-testid="auto-edit-panel-button-1" type="button" class="ql-undo" aria-label="Undo" matTooltip="Undo" [matTooltipClass]="{ 'red-tooltip text-black': true }">
        <i class="fa-solid fa-rotate-left"></i>
      </button>
      <button data-testid="auto-edit-panel-button-2" type="button" class="ql-redo" aria-label="Redo" matTooltip="Redo" [matTooltipClass]="{ 'red-tooltip text-black': true }">
        <i class="fa-solid fa-rotate-right"></i>
      </button>
    </span>
                <span class="ql-formats">
                  <select data-testid="auto-edit-panel-select-9" class="ql-font">
                    <option value="poppins" selected>Poppins</option>
                    <option value="sans-serif">Sans Serif</option>
                    <option value="monospace">Monospace</option>
                    <option value="arial">Arial</option>

                  </select>
                  <select data-testid="auto-edit-panel-select-10" class="ql-header">
                  <option value="1">Heading</option>
                  <option value="2">Subheading</option>
                  <option selected></option>

                </select>

                  <button data-testid="auto-edit-panel-button-3" type="button" class="ql-bold" aria-label="Bold" matTooltip="Bold" [matTooltipClass]="{ 'red-tooltip text-black': true }"></button>
                  <button data-testid="auto-edit-panel-button-4" type="button" class="ql-italic" aria-label="Italic" matTooltip="Italic" [matTooltipClass]="{ 'red-tooltip text-black': true }" ></button>
                  <button data-testid="auto-edit-panel-button-5" type="button" class="ql-underline" aria-label="Underline" matTooltip="Underline" [matTooltipClass]="{ 'red-tooltip text-black': true }" ></button>
                  <button data-testid="auto-edit-panel-button-6" type="button" class="ql-list" aria-label="Unordered list" value="bullet" matTooltip="Bulleted list" [matTooltipClass]="{ 'red-tooltip text-black': true }"></button>
                  <button data-testid="auto-edit-panel-button-7" type="button" class="ql-list" aria-label="Ordered list" value="ordered" matTooltip="Ordered list" [matTooltipClass]="{ 'red-tooltip text-black': true }"></button>

                 <button data-testid="auto-edit-panel-button-8" class="ql-indent" value="-1" aria-label="Indent less"></button>
                <button data-testid="auto-edit-panel-button-9" class="ql-indent" value="+1" aria-label="Indent more"></button>

                  <button data-testid="auto-edit-panel-button-10" class="ql-blockquote"  matTooltip="Blockquote" [matTooltipClass]="{ 'red-tooltip text-black': true }"></button>
                  <button data-testid="auto-edit-panel-button-11" class="ql-strike" matTooltip="Strikethrough" [matTooltipClass]="{ 'red-tooltip text-black': true }" ></button>
                  <button data-testid="auto-edit-panel-button-12" type="button" class="ql-link" aria-label="Insert link" (click)="insertLink($event)"  matTooltip="Link" [matTooltipClass]="{ 'red-tooltip text-black': true }" ></button>
                  <button data-testid="auto-edit-panel-button-13" type="button" class="ql-clean" aria-label="Remove Styles" matTooltip="Remove styles" [matTooltipClass]="{ 'red-tooltip text-black': true }"></button>

                  <button data-testid="auto-edit-panel-button-14" type="button" class="ql-image"  matTooltip="Upload Image" [matTooltipClass]="{ 'red-tooltip text-black': true }"></button>
                  <span  matTooltip="Text color" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <select data-testid="auto-edit-panel-select-11" class="ql-color"></select></span>
                  <span  matTooltip="Background color" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <select data-testid="auto-edit-panel-select-12" class="ql-background"></select></span>
                   <span type="button" matTooltip="Text Alignment" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                    <select data-testid="auto-edit-panel-select-13" class="ql-align" title="Text Alignment">
                      <option selected>Gauche</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                  </span>
              </span>
                    <!-- <span class="ql-formats">
                      <select data-testid="auto-edit-panel-select-14" class="ql-color"></select>
                      <select data-testid="auto-edit-panel-select-15" class="ql-background"></select>
                    </span> -->
                <!-- <div >
                  <p-dropdown (onChange)="selectplaceholder($event)" placeholder="Select Placeholder" [options]="placeholderlist" optionLabel="value" [disabled]="!placeid" formControlName="placeholder"></p-dropdown>
                </div> -->
            </p-header>
          </p-editor>
          <!-- START: AI Compose Region -->
          <div *ngIf="showAIAssist"
            class="position-absolute d-flex flex-column justify-content-center align-items-center"
            style="top: 0;left: 0;height: 100%;width: 100%;text-align: center;">
            <h5 class="ai-text-gradient pb-3 font-weight-600">
              Craft messages your way - <span class="ai-title"></span>
            </h5>
            <p style="width: 40%;">
              We suggest you choose Gen AI to free up your time for other recruitment tasks.
            </p>
            <div class="pb-2">
              <button data-testid="auto-edit-panel-button-15" type="button" (click)="showAIAssistModal()" class="wc-btn gradientbtn"><i class="fa fa-stars"></i>
                Generate with Gen AI</button>
            </div>
            <p class="mb-0">
              Or <span class="pointer text-webbtree-green" style="text-decoration-line: underline;"
                (click)="composeManually()">compose manually</span>
            </p>
          </div>
          <div class="position-absolute m-4" [ngClass]="showAIAssist ? 'd-none' : 'd-flex'"
            style="bottom: 0; right: 0;">
            <div *ngIf="composeType == 'AI'" class="d-flex rounded-pill c-shadow" style="padding: 0.2em">
              <button data-testid="auto-edit-panel-button-16" type="button" (click)="showAIAssistModal()" class="wc-btn compose-btn"><i
                  class="ai-text-gradient fa fa-gear"></i></button>
            </div>
            <div *ngIf="composeType == 'MANUAL'" class="d-flex rounded-pill c-shadow" style="padding: 0.2em">
              <button data-testid="auto-edit-panel-button-17" type="button" (click)="showAIAssistModal()"
                class="wc-btn gradientbtn rounded-pill with-animation"><i class="fa fa-stars"></i><span
                  class="type-me"></span></button>
            </div>
          </div>
          <!-- END: AI Compose Region -->
        </div>
        <div class="sec2">
          <p *ngIf="stageFormGroup.get('body').errors?.required && (stageFormGroup['controls'].body.touched)"
            class="f-12 text-danger"> Body is required</p>
          <p class="f-12 text-danger" *ngIf="stageFormGroup.get('body').hasError('notOnlyWhitespace')">
            Body cannot be only whitespace.
          </p>
          <!-- </div> -->
          <!-- <br /> -->
        </div>

      <div style="margin: 12px;">
        <app-attachment-list
          [files]="attachments.current"
          mode="edit"
          (fileRemoved)="removeAttachment($event)"
          (filesSelected)="addAttachment($event)"
          >
        </app-attachment-list>
        <div *ngIf="stageIndex == 0" style="color: #B8B8B8;" class="f-10 font-weight-400 mt-2">
          <i class="fa-sharp fa-light fa-lightbulb-on"></i>
          Emails without attachments in the first step generally help improve deliverability and inbox placement.
        </div>
      </div>

        <div class="d-flex justify-content-between m-2 align-items-center">
          <div class="d-flex">
            <div class="d-flex align-items-center ml-1">
              <input data-testid="auto-edit-panel-input-6" type="checkbox" class="" formControlName="isUnsubscribed">
              <label class="saveAsTemplate">User can Unsubscribe</label>
            </div>
            <div class="d-flex align-items-center ml-5">
              <input data-testid="auto-edit-panel-input-7" type="checkbox" (change)="toggleSaveAsTemplate($event)" [checked]="IsChecked">
              <label class="saveAsTemplate">Save as Template</label>
            </div>
          </div>
          <div class="d-flex" style="gap: 0.5rem;">
            <button data-testid="auto-edit-panel-button-18" type="button" class="wc-btn wc-ghostBtn" (click)="onCancel()">
              Cancel
            </button>
            <button data-testid="auto-edit-panel-button-19" type="submit" class="btn-trms-small" [class.disabled]="stageFormGroup.invalid" [disabled]="stageFormGroup.invalid">
              <span *ngIf="!uploadAttachmentInProgress">
                Save
              </span>
              <span *ngIf="uploadAttachmentInProgress">
                <img style="width: 22px;" src="./../../../assets/rolling-loader-white.gif" alt="loader" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="stage && !isInEditMode.editMode" class="non-editable-form">
      <div class="panel-heading">
        <span class="Heading-text"
          style="max-width: 20vw;white-space: nowrap;overflow: hidden;display: block;text-overflow: ellipsis;width: 19vw;cursor:default;"
          matTooltip="{{ stage.stage_name }}" [matTooltipClass]="{ 'red-tooltip text-black': true }">
          {{ stage.stage_name }}
        </span>
      </div>
      <div class="sec-preview">
        <label class="field-label mr-2 mt-1">When: </label>
        <span class="field-value snd-aftr ml-2">
          <span *ngIf="!stage?.after_id && !prevStageId"> Send Email <b>
              Between
            </b>
          </span>
          <span class="mx-3" style="color:#d9d9d9;" *ngIf="!stage?.after_id && !prevStageId">|</span>
          <span class="mx-1" *ngIf="!stage?.after_id && !prevStageId">Time <i
              class="fa-sharp fa-regular fa-clock mx-1"></i> {{getSchedule(campaign_details.schedule)}}
          </span>
          <span class="mx-3" *ngIf="!stage?.after_id && !prevStageId">
            <i class="fa-regular fa-globe mx-1"></i> {{timezonePreview}}
          </span>
          <span class="mx-3" style="color:#d9d9d9;" *ngIf="!stage?.after_id && !prevStageId">|</span>
          <span class="mx-1" *ngIf="!stage?.after_id && !prevStageId">
            Follow-up on <b>{{ (campaign_details?.regular_days != null ? campaign_details?.regular_days : stage.regular_days) ? 'Regular' : 'Business' }} days</b>
          </span>
          <span class="field-value snd-aftr " *ngIf="stage?.after_id && prevStageId">
            Send email after
            <b>{{ afterDays }} Days on
              {{ (campaign_details?.regular_days != null ? campaign_details?.regular_days : stage.regular_days) ? 'Regular' : 'Business' }} days </b>on no reply
          </span>

        </span>
      </div>
      <hr />
      <div class="sec-preview">
        <label class="field-label mr-5">To: </label>
        <span class="field-value select-cand ml-4">
          {{toOptions[campaign_details.email_pref-1]}}
        </span>
      </div>
      <hr />
      <div class="sec-preview">
        <label class="field-label mr-5">From: </label>
        <span class="field-value from ml-1">{{getFromValue(campaign_details.useremailintegrationid)}} </span>
      </div>
      <hr />
      <div class="sec-preview d-flex" style="align-items: flex-start;">
        <div>
          <label class="field-label mr-3 mb-1" style="line-height: 210%;">Subject: </label>
        </div>
        <div>
          <span class="field-value sbj" style="line-height: 210%;"
            [innerHTML]="renderPills(stage.subject, 'subject')"></span>
        </div>
      </div>
      <div *ngIf="campaign_details.keep_thread && !stage.after_id" class="bg-color-company d-inline-block f-12 my-0 px-2 py-2 rounded sec-preview">
        <i class="fa fa-info-circle mr-1"></i>
        Follow-up emails will be sent in the same thread using the first email’s subject
      </div>
      <!-- <hr />
      <label class="field-label ml-3 mt-1 mb-1">Body: </label> -->
      <div class="sec-preview-2 text-editor-in-preview-mode">

        <!-- <p-editor [innerHTML]="stage.body" [style]="{ 'height': '100%' }"  [readonly]="true" style="cursor: no-drop;">
          <p-header class="d-flex justify-content-between">
            <span class="ql-formats">
              <button data-testid="auto-edit-panel-button-20" class="ql-bold"></button>
              <button data-testid="auto-edit-panel-button-21" class="ql-italic"></button>
              <button data-testid="auto-edit-panel-button-22" class="ql-underline"></button>
              <button data-testid="auto-edit-panel-button-23" class="ql-clean"></button>
            </span>
            <div >
            </div>
          </p-header>
        </p-editor> -->
        <div [innerHTML]="renderPills(stage.body, 'body')">

        </div>
      </div>
      <div *ngIf="attachments.existing.length > 0" style="margin: 12px;">
        <app-attachment-list [files]="attachments.existing" mode="view">
        </app-attachment-list>
      </div>
      <div class="d-flex justify-content-end m-3 align-items-center" style="gap: 0.5rem;" *ngIf="!readOnly">
        <button data-testid="auto-edit-panel-button-24" class="wc-btn wc-ghostBtn" (click)="openTestEmailConfirmationModal()">
          <ng-container *ngIf="!isSendingTestEmail && !testEmailSent">
            <span class="pointer">Send test email</span>
          </ng-container>
          <ng-container *ngIf="isSendingTestEmail && !testEmailSent">
            <span class="pointer">Sending</span>
            <span class="fa fa-spin fa-spinner ml-2"></span>
          </ng-container>
          <ng-container *ngIf="!isSendingTestEmail && testEmailSent">
            <span class="pointer">Sent</span>
            <span class="fa fa-check ml-2"></span>
          </ng-container>
        </button>
        <div>
          <button data-testid="auto-edit-panel-button-25" (click)="setEditMode()" class="wc-btn wc-primary px-7">Edit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #testMailConfirmation>
  <div class="header d-flex  align-items-center m-3">
    <div><i class="fa-solid fa-envelope mr-1" style="color: #2e93a1;"></i>
      <span class='modal-heading'>
        Send Test Email
      </span>
    </div>

    <div>
      <span (click)="closeModal()" class="close-btn">
        <i class="fa-regular fa-xmark" style="color: #2c2c2c;"></i>
      </span>
    </div>
  </div>
  <div class="mx-3">
    <form [formGroup]="testEmailFormGroup">
      <label for="testEmail">Email address</label>
      <input data-testid="auto-edit-panel-input-8" placeholder="Test Email" type="email" formControlName="testEmail" name="testEmail" class='form-control form-control-sm' />
    </form>
    <p class="f-12 mb-0 mt-2">This test email will be sent to the campaign selected email id.<br />Are you sure you want
      to send?</p>
  </div>
  <div class="d-flex justify-content-end m-3">
    <button data-testid="auto-edit-panel-button-26" class="wc-btn wc-primary" (click)="sendTestEmail(campaign_details.useremailintegrationid)">
      <ng-container *ngIf="!isSendingTestEmail && !testEmailSent">
        <span *ngIf="!isSendingTestEmail">Send</span>
      </ng-container>
      <ng-container *ngIf="isSendingTestEmail && !testEmailSent">
        <span>Sending</span>
        <span class="fa fa-spin fa-spinner ml-2"></span>
      </ng-container>
      <ng-container *ngIf="!isSendingTestEmail && testEmailSent">
        <span>Sent</span>
        <span class="fa fa-check ml-2"></span>
      </ng-container>
    </button>
  </div>
</ng-template>


<ng-template #createTemplateModal>
  <div>
    <div class="header d-flex  align-items-center m-3">
      <div><i class="fa-solid fa-envelope mr-1" style="color: #2e93a1;"></i>
        <span class='modal-heading'>
          Create Template
        </span>
      </div>

      <div>
        <span (click)="closeModal()" class="close-btn">
          <i class="fa-regular fa-xmark" style="color: #2c2c2c;"></i>
        </span>
      </div>
    </div>
  </div>
  <div style="margin: 0 1rem 1rem 1rem">
    <!-- Add the 'required' attribute to enforce the required validation -->
    <form #form="ngForm" novalidate>
      <label for="templateName">Template name</label>
      <br>
      <input data-testid="auto-edit-panel-input-9" placeholder="Template name" [(ngModel)]="modalData.templateName" name="templateName" class='campaign-inpt'
        required />
      <!-- Display a validation message if the templateName is required and not provided -->
      <div
        *ngIf="form.controls['templateName'] && form.controls.templateName.errors?.required &&  (form.controls.templateName.dirty || form.controls.templateName.touched)"
        class="error-message">
        Template name is required.
      </div>
    </form>
  </div>
  <div class="d-flex justify-content-end">

    <button data-testid="auto-edit-panel-button-27" class="btn-trms-small" (click)="createTemplate()"
      [disabled]="form.controls['templateName'] && form.controls.templateName.errors?.required && (form.controls.templateName.dirty || form.controls.templateName.touched)">Add</button>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
